<template>
  <el-scrollbar>
    <el-form ref="ff" label-width="120px" :model="formdata">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="信息来源" prop="Source" required>
            <metaPicker
              type="demand-from"
              :value.sync="formdata.Source"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索分类" prop="Type" required>
            <metaPicker
              type="demand-type"
              :value.sync="formdata.Type"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计销售金额" prop="ProAmount">
            <el-input v-model="formdata.ProAmount" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计签单日期" prop="ProDealDate">
            <el-date-picker
              type="date"
              v-model="formdata.ProDealDate"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户单位" prop="Client" required>
            <clientPicker
              v-model="formdata.Client"
              allow-create
              default-first-option
              clearable
              style="width: 100%"
              @change="onClient"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系地址" prop="Address">
            <el-input v-model="formdata.Address" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系人" prop="Linkman">
            <el-input v-model="formdata.Linkman" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="性别" prop="Gender">
            <el-select v-model="formdata.Gender" clearable>
              <el-option value="男">男</el-option>
              <el-option value="女">女</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="部门" prop="Dept">
            <el-input v-model="formdata.Dept" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="职务" prop="Job">
            <el-input v-model="formdata.Job" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工作电话" prop="Worktel">
            <el-input v-model="formdata.Worktel" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系电话" prop="Linktel">
            <el-input v-model="formdata.Linktel" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="QQ号、微信" prop="QQ">
            <el-input v-model="formdata.QQ" clearable />
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="复印机" prop="NeedCopier">
            <el-input v-model="formdata.NeedCopier" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="打印机" prop="NeedPrinter">
            <el-input v-model="formdata.NeedPrinter" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="其它设备" prop="NeedOther">
            <el-input v-model="formdata.NeedOther" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求备注" prop="Explain">
            <el-input v-model="formdata.Explain" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="我们占比印量" prop="WeAmount">
            <el-input-number v-model="formdata.WeRatio" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="我们消费金额" prop="WeFee">
            <el-input-number v-model="formdata.WeFee" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="每月总印量" prop="MonthlyAmount">
            <el-input-number v-model="formdata.MonthlyAmount" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="每月消费金额" prop="MonthlyFee">
            <el-input-number v-model="formdata.MonthlyFee" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="预估年印量" prop="YearlyAmount">
            <el-input-number v-model="formdata.YearlyAmount" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
          v-loading.fullscreen.lock="loading"
        >
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </el-scrollbar>
</template>
  
<script>
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    clientPicker: () => import("@/views/company/customer/_picker.vue"),
  },
  data() {
    return {
      loading: false,
      formdata: {},
    };
  },
  created() {
    let id = this.$route.query?.id;
    if (id) {
      this.$apis.job.demand
        .info({
          id: id,
        })
        .then((res) => {
          if (res != null) {
            this.formdata = res;
          } else {
            this.$router.go(-1);
          }
        });
    }
  },
  methods: {
    //选择客户
    onClient(res) {
      this.$set(this.formdata, "CustomerId", res.Id);
      this.$set(this.formdata, "Client", res.Name);
      this.$set(this.formdata, "Address", res.Address);
      this.$set(this.formdata, "Linkman", res.Linkman);
      this.$set(this.formdata, "Linktel", res.Linktel);
    },
    //提交数据
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true;
          this.$apis.job.demand
            .submit(this.formdata)
            .then(() => {
              this.$message({ message: "数据提交成功！", type: "success" });
              this.$router.push("public");
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.el-form {
  background: #fff;
  min-height: 100%;
  padding: 20px 40px;
}
</style>